import _BaseAPIService from "../_BaseAPIService"

const apiService = _BaseAPIService.instance;

const PublicAccessService = {
  

    update: async (updatedData) => {
        try{

            const response = await apiService.put(`/public-page-access/password`,updatedData);
            return response.data;
        }
        catch(err)
        {
            console.log(err)
        }
    },

 
}

export default PublicAccessService;